import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { NgSessionStorage } from 'core/utils/ng-storage.service';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Dashboard';
  currentEnvironment = environment;

  constructor(@Inject(DOCUMENT) private readonly document: any,
    private router: Router,    
    private ngSessionStorage: NgSessionStorage
    ) { }

  ngOnInit(): void {

    this.router.events
      .pipe(
        filter(value => value instanceof NavigationEnd),
      )
      .subscribe((event: any) => {
        let dashboardRedirectPrevUrl = this.ngSessionStorage.getItem("dashboardRedirectPrevUrl");
        if(dashboardRedirectPrevUrl!=null && dashboardRedirectPrevUrl!=undefined)
        {
          if ((event.url === '/' || event.url === '/dashboard') && dashboardRedirectPrevUrl !== window.location.origin + '/') {
          //  this.ngSessionStorage.removeItem("dashboardRedirectPrevUrl");
           // window.location.reload();
          }
        }
      });
  }

}
